export default __webpack_public_path__ + "f379c0015c12de1bed9c69f206923eec.png";